export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#003366] text-white py-10 md:py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col items-center md:flex-row md:justify-between md:items-center mb-8 md:mb-12 gap-6">
          <div className="flex justify-center md:justify-start">
            <img
              src="https://static.readdy.ai/image/402fb013a15abdbe1b740b2d8ca8aa4c/a0082163fda938ccc063740b372592ae.png"
              alt="Satori Energia"
              className="h-10 md:h-12"
            />
          </div>
          <div className="flex flex-col items-center md:items-end gap-4">
            <div className="flex space-x-4">
              <a
                href="https://www.youtube.com/channel/UClGShZvxU9U9vmGAnHorx6A"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-all duration-300 w-10 h-10 flex items-center justify-center"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-xl"></i>
              </a>
              <a
                href="https://www.facebook.com/satorienergia"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-all duration-300 w-10 h-10 flex items-center justify-center"
                aria-label="Facebook"
              >
                <i className="ri-facebook-line text-xl"></i>
              </a>
              <a
                href="https://www.linkedin.com/company/74341299/admin/dashboard/"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-all duration-300 w-10 h-10 flex items-center justify-center"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-xl"></i>
              </a>
              <a
                href="https://www.instagram.com/satorienergia"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-white/10 hover:bg-white/20 p-2 rounded-full transition-all duration-300 w-10 h-10 flex items-center justify-center"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
            <div className="flex items-center text-sm md:text-base">
              <i className="ri-phone-line mr-2"></i>
              <span>(89) 93300-9903</span>
            </div>
            <button
              onClick={scrollToTop}
              className="bg-white/10 hover:bg-white/20 text-white p-3 rounded-full transition-all duration-300 w-10 h-10 flex items-center justify-center cursor-pointer"
              aria-label="Voltar ao topo"
            >
              <i className="ri-arrow-up-line text-xl"></i>
            </button>
          </div>
        </div>
        <div className="border-t border-white/20 pt-6 md:pt-8">
          <div className="text-center md:flex md:justify-between text-xs md:text-sm text-white/70 gap-2">
            <p>© 2025 Satori Energia. Todos os direitos reservados.</p>
            <div className="mt-2 md:mt-0">
              <a href="https://readdy.ai/?ref=logo" className="hover:text-white transition-colors">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
